import { CheckAllIcon } from './CheckAllIcon';

/**
 * author: Google
 * id 48BA3B7B-1EF7-4160-A0BB-54EBCF999A13
 * name check-all
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-all.svg
 * tags
 */
export const TicksIcon = CheckAllIcon;
export default TicksIcon